import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

const mutation = gql`
  mutation navigatorNoteSampleDestroy($id: ID!) {
    navigatorNoteSampleDestroy(id: $id) {
      id
    }
  }
`

export default function useNavigatorNoteSampleDestroy() {
  const { onMutate: onNavigatorNoteSampleDestroy, loading } =
    useSafeRunMutation({
      mutation,
      responsePath: 'navigatorNoteSampleDestroy',
      successMessage: ''
    })
  return { onNavigatorNoteSampleDestroy, loading }
}
